import { errorCodes } from "@chesshotel/constants";
import { api } from "../services/api";

export function validatePassword(password: string) {
  if (password == null || password.length < 4) {
    return errorCodes.ERROR_PASSWORD_TOO_SHORT;
  } else if (password.length > 50) {
    return errorCodes.ERROR_PASSWORD_TOO_LONG;
  }
}

export function validateConfirmPassword(
  password: string,
  confirmPassword: string
) {
  if (password != null && password !== confirmPassword) {
    return errorCodes.ERROR_PASSWORDS_DO_NOT_MATCH;
  }
}

export async function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!re.test(email)) {
    return errorCodes.ERROR_EMAIL_NOT_VALID;
  } else {
    try {
      await api.post("/users/email-available", { email });
    } catch (err) {
      return errorCodes.ERROR_EMAIL_NOT_AVAILABLE;
    }
  }
}

export function validateCountry(country: string) {
  if (country === "") {
    return errorCodes.ERROR_NO_COUNTRY;
  }
}

export async function validateUsername(username: string, locale: string) {
  if (username == null || username.length < 4) {
    return errorCodes.ERROR_USERNAME_TOO_SHORT;
  } else if (username.length > 15) {
    return errorCodes.ERROR_USERNAME_TOO_LONG;
  } else {
    const wash = await import("washyourmouthoutwithsoap");
    if (wash.check("en", username) || wash.check(locale, username)) {
      return errorCodes.ERROR_USERNAME_NOT_AVAILABLE;
    } else {
      try {
        await api.post("/users/username-available", { username });
      } catch (err) {
        return errorCodes.ERROR_USERNAME_NOT_AVAILABLE;
      }
    }
  }
}
